export const ROLE = {

    DIRECTOR: 'ROLE_DIRECTOR',
    DIETIST: 'ROLE_DIETIST',
    CULINARY: 'ROLE_CULINARY',
    MANAGER: 'ROLE_MANAGER',
    DEMO: 'ROLE_DEMO'

}